import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CTABanner({ headline, text, buttonText, buttonTo, variant = 'dark', onButtonClick }) {
  const isDark = variant === 'dark';
  const primaryClasses = `inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-sm font-semibold transition-all ${
    isDark
      ? 'bg-emerald-400 text-stone-950 hover:bg-emerald-300 shadow-md hover:shadow-lg'
      : 'bg-stone-900 text-white hover:bg-stone-800 hover:shadow-neon'
  }`;
  return (
    <section className={`py-24 sm:py-32 relative overflow-hidden ${isDark ? 'bg-stone-950' : 'bg-white'}`} data-testid="cta-banner">
      {isDark && (
        <div
          className="absolute inset-0 opacity-40 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 50% 100%, rgba(62,255,126,0.15) 0%, transparent 60%)' }}
          aria-hidden="true"
        />
      )}
      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <h2 className={`font-display text-[2.4rem] sm:text-[3.75rem] lg:text-[4.5rem] tracking-[-0.028em] leading-[0.98] mb-7 ${isDark ? 'text-white' : 'text-stone-900'}`}>
          {headline || <>Jede Reise.<br/><span className="text-stone-400">Jeder Kilometer. Zurück an dich.</span></>}
        </h2>
        <p className={`font-body-refined text-base sm:text-lg mb-10 max-w-xl mx-auto leading-[1.6] ${isDark ? 'text-stone-400' : 'text-stone-500'}`}>
          {text || 'Deine virtuelle FuelX Card ist sofort aktiv — noch bevor du das Wochenende buchst. Ab 99,90 € im Jahr.'}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {onButtonClick ? (
            <button
              type="button"
              onClick={onButtonClick}
              className={primaryClasses}
              data-testid="cta-primary"
            >
              {buttonText || 'Card bestellen'} <ArrowRight className="w-4 h-4" strokeWidth={2} />
            </button>
          ) : (
            <Link to={buttonTo || '/preise'} className={primaryClasses} data-testid="cta-primary">
              {buttonText || 'Card bestellen'} <ArrowRight className="w-4 h-4" strokeWidth={2} />
            </Link>
          )}
          <Link
            to="/so-funktionierts"
            className={`inline-flex items-center justify-center px-8 py-4 rounded-full text-sm font-medium border transition-colors ${
              isDark ? 'border-stone-700 text-stone-300 hover:border-stone-500' : 'border-stone-200 text-stone-600 hover:border-stone-400'
            }`}
            data-testid="cta-secondary"
          >
            So funktioniert&rsquo;s
          </Link>
        </div>
      </div>
    </section>
  );
}
